import { useState } from 'react';
import { Provider } from 'react-redux';
import { Route, Routes, useLocation } from 'react-router-dom';
import './App.css';
import BeerLine from './components/beerLine/beerLine';
import BuildTowers from './components/buildTower/buildTower';
import Contact from './components/contact/contact';
import LandingPage from './components/landing-page/landing-page';
import NavWithRouter from './components/navbar/navbar';
import SystemInstallation from './components/system/systemInstallation';
import WildCard from './components/wildCard/wildCard';
import store from './store';
import Login from './components/login/login';

function App() {
  const findBootstrapEnvironment = () => {
    const envs = ['xs', 'sm', 'md', 'lg', 'xl'];
    const el = document.createElement('div');
    document.body.appendChild(el);

    let curEnv = envs.shift();

    for (let env of envs.reverse()) {
      el.classList.add(`d-${env}-none`);

      if (window.getComputedStyle(el).display === 'none') {
        curEnv = env;
        break;
      }
    }

    document.body.removeChild(el);
    return curEnv;
  }

  const [deviceSize, setDeviceSize] = useState(findBootstrapEnvironment());

  window.addEventListener('resize', () => {
    // console.log('resizing',findBootstrapEnvironment());
    setDeviceSize(findBootstrapEnvironment());
  });

  return (
    <div className="App">
      <Provider store={store}>
        <NavWithRouter location={useLocation().pathname} device={deviceSize} />
        <Routes>
          <Route path="/" element={<LandingPage device={deviceSize} />} />
          <Route path="/about" element={<LandingPage device={deviceSize} />} />
          <Route path="/beerline" element={<BeerLine />} />
          <Route path="/systems" element={<SystemInstallation />} />
          <Route path="/buildtowers" element={<BuildTowers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<WildCard />} />
        </Routes>
      </Provider>
    </div>
  );
}

export default App;
